import HealthMonitor from '@omni/kit/HealthMonitor';
import { getStoredItem, setStoredItem } from '@omni/kit/storage';
import moment from 'moment';
import { useEffect, useState } from 'react';

const useGroupEventCallout = (
  isManager: boolean | undefined
): {
  showGroupEventCallout: boolean;
  showGroupEventBadge: boolean;
  setShowGroupEventBadge: (b: boolean) => void;
  setShowGroupEventCallout: (b: boolean) => void;
} => {
  const [showGroupEventCallout, setShowGroupEventCallout] = useState(false);
  const [showGroupEventBadge, setShowGroupEventBadge] = useState(false);

  useEffect(() => {
    const handleGroupEventCallout = async () => {
      try {
        const storedCallout = await getStoredItem('showGroupEventCallout');

        if (storedCallout === null && isManager) {
          await setStoredItem('showGroupEventCallout', 'true');
          setShowGroupEventCallout(true);
        }

        const badgeDate = await getStoredItem('showGroupEventBadgeDate');

        if (badgeDate === null) {
          const currentDate = moment().toISOString();
          await setStoredItem('showGroupEventBadgeDate', currentDate);
          setShowGroupEventBadge(true);
        } else {
          const currentDate = moment();
          const savedDate = moment(badgeDate);
          const sixtyDaysLater = savedDate.add(60, 'days');

          if (currentDate.isAfter(sixtyDaysLater)) {
            setShowGroupEventBadge(false);
          } else {
            setShowGroupEventBadge(true);
          }
        }
      } catch (e) {
        HealthMonitor.logError(e);
      }
    };

    handleGroupEventCallout();
  }, [isManager]);

  return {
    showGroupEventCallout,
    showGroupEventBadge,
    setShowGroupEventBadge,
    setShowGroupEventCallout,
  };
};

export default useGroupEventCallout;
